"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchInput;
Object.defineProperty(exports, "SearchInputProps", {
  enumerable: true,
  get: function get() {
    return _types.SearchInputProps;
  }
});
Object.defineProperty(exports, "SearchItem", {
  enumerable: true,
  get: function get() {
    return _types.SearchItem;
  }
});
Object.defineProperty(exports, "StyledFlexProps", {
  enumerable: true,
  get: function get() {
    return _types.StyledFlexProps;
  }
});

var _react = _interopRequireWildcard(require("react"));

var _Times = _interopRequireDefault(require("@decisiv/iconix/lib/components/Times"));

var _Search = _interopRequireDefault(require("@decisiv/iconix/lib/components/Search"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Button = _interopRequireDefault(require("../Button"));

var _InputField = _interopRequireDefault(require("../../atoms/InputField"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _types = require("./types");

var _Input = _interopRequireDefault(require("../TextField/Input"));

var _useUpdateEffect = _interopRequireDefault(require("../../utils/useUpdateEffect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledFlex = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "SearchInput__StyledFlex",
  componentId: "sc-1lgi0sd-0"
})(["align-items:center;[cursor='text']{height:", "px;> div{", ";padding-bottom:", ";}}"], function (_ref) {
  var mediumSized = _ref.mediumSized;
  return mediumSized ? 50 : 32;
}, function (_ref2) {
  var mediumSized = _ref2.mediumSized;
  return !mediumSized && "padding-top: ".concat((0, _rem.default)(_spacing.default.base * 0.1));
}, function (_ref3) {
  var mediumSized = _ref3.mediumSized;
  return (0, _rem.default)(_spacing.default.base * (mediumSized ? 0.6 : 0.1));
});
var StyledBody = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "SearchInput__StyledBody",
  componentId: "sc-1lgi0sd-1"
})(["flex:1;align-items:center;height:inherit;"]);
var ButtonGroup = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "SearchInput__ButtonGroup",
  componentId: "sc-1lgi0sd-2"
})(["align-items:center;margin-right:", ";cursor:default;"], function (_ref4) {
  var mediumSized = _ref4.mediumSized;
  return (0, _rem.default)(_spacing.default.base * (mediumSized ? 1 : 0.3));
});
var SearchIconWrapper = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "SearchInput__SearchIconWrapper",
  componentId: "sc-1lgi0sd-3"
})(["color:", ";margin-right:", ";margin-left:", ";align-items:center;"], (0, _toColorString.default)(_color.default.base.alaskanHusky), (0, _rem.default)(_spacing.default.base * 1.5), function (_ref5) {
  var inputSize = _ref5.inputSize;
  return inputSize === 'small' ? 0 : (0, _rem.default)(_spacing.default.base * 0.5);
});
var TimesIconWrapper = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "SearchInput__TimesIconWrapper",
  componentId: "sc-1lgi0sd-4"
})(["height:inherit;visibility:", ";margin-right:", ";color:", ";align-items:center;border:1px solid transparent;border-radius:2px;&:hover{color:", ";}&:focus{outline:none;border:1px solid ", ";", "}"], function (_ref6) {
  var visible = _ref6.visible;
  return visible ? 'visible' : 'hidden';
}, (0, _rem.default)(_spacing.default.base), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.status.danger.medium), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _focusRingWithColor.default)(_color.default.interaction.pacificOcean40));
var StyledInput = (0, _styledComponents.default)(_Input.default).withConfig({
  displayName: "SearchInput__StyledInput",
  componentId: "sc-1lgi0sd-5"
})(["padding:0;color:", ";"], (0, _toColorString.default)(_color.default.base.charcoal));

function SearchInput(_ref7) {
  var onSearch = _ref7.onSearch,
      value = _ref7.value,
      onChange = _ref7.onChange,
      size = _ref7.size,
      disabled = _ref7.disabled,
      _ref7$searchOn = _ref7.searchOn,
      searchOn = _ref7$searchOn === void 0 ? 'submit' : _ref7$searchOn,
      props = _objectWithoutProperties(_ref7, ["onSearch", "value", "onChange", "size", "disabled", "searchOn"]);

  var translate = (0, _useTranslations.default)();
  var handleSearch = (0, _react.useCallback)(function () {
    !disabled && onSearch && onSearch(value);
  }, [disabled, onSearch, value]);
  var mediumSized = size === 'medium';
  var hasText = !!value && !!value.length;
  var handleClear = (0, _react.useCallback)(function () {
    !disabled && onChange && onChange({
      target: {
        value: ''
      }
    });
  }, [disabled, onChange]);
  var handleKeyPress = (0, _react.useCallback)(function (event) {
    if (event.key === 'Enter') handleSearch();
  }, [handleSearch]);
  (0, _useUpdateEffect.default)(function () {
    if (searchOn === 'change') {
      handleSearch();
    }
  }, [searchOn, value]);
  var renderLeftIcon = searchOn === 'change' || searchOn === 'submit' && mediumSized;
  return _react.default.createElement(StyledFlex, {
    flex: 1,
    mediumSized: mediumSized,
    "data-testid": "search-container"
  }, _react.default.createElement(_InputField.default, _extends({
    label: "",
    hideLabel: true,
    disabled: disabled,
    value: value
  }, props), function (p) {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledBody, null, renderLeftIcon && _react.default.createElement(SearchIconWrapper, {
      inputSize: size
    }, _react.default.createElement(_Search.default, {
      size: "medium",
      "data-testid": "search-icon"
    })), _react.default.createElement(StyledInput, _extends({}, p, {
      onChange: onChange,
      onKeyPress: handleKeyPress
    })), _react.default.createElement(ButtonGroup, {
      mediumSized: mediumSized
    }, !disabled && _react.default.createElement(_Tooltip.default, {
      placement: "top",
      target: // eslint-disable-next-line react/jsx-wrap-multilines
      _react.default.createElement(TimesIconWrapper, {
        tabIndex: 0,
        "aria-label": translate(undefined, 'searchInput.clearSearch'),
        onClick: handleClear,
        visible: hasText
      }, _react.default.createElement(_Times.default, {
        size: "small"
      }))
    }, translate(undefined, 'searchInput.clear')), searchOn === 'submit' && _react.default.createElement(_Button.default, {
      "aria-label": "Search",
      tabIndex: 0,
      disabled: disabled || !hasText,
      text: mediumSized ? translate(undefined, 'searchInput.search') : '',
      icon: mediumSized ? undefined : _Search.default,
      size: size,
      onClick: handleSearch
    }))));
  }));
}

SearchInput.defaultProps = {
  size: 'medium'
};